import { render, staticRenderFns } from "./carDamage.vue?vue&type=template&id=2a1af2b5&scoped=true"
import script from "./carDamage.vue?vue&type=script&lang=js"
export * from "./carDamage.vue?vue&type=script&lang=js"
import style0 from "./carDamage.vue?vue&type=style&index=0&id=2a1af2b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1af2b5",
  null
  
)

export default component.exports